<template>
  <div class="uk-grid uk-child-width-1-1" data-uk-grid>
    <div>
      <div class="uk-flex uk-flex-between uk-flex-middle">
        <div>
          <h1 class="uk-h4 uk-margin-remove">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M5 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                <path d="M19 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                <path d="M19 8v5a5 5 0 0 1 -5 5h-3l3 -3m0 6l-3 -3"></path>
                <path d="M5 16v-5a5 5 0 0 1 5 -5h3l-3 -3m0 6l3 -3"></path>
              </svg>
            </span>
            Restwertbörse
          </h1>
        </div>
        <div>
          <a @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-secondary">
            <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
            Zurück
          </a>
        </div>
      </div>
    </div>
    <div>
      <p>
        Sie haben ab sofort die Möglichkeit sich schon heute interessante Jungwagen zu sichern, indem Sie uns ein
        Restwertangebot unterbreiten, für Fahrzeuge die wir beschaffen möchten. <br>
        Wir prüfen dann alle eingehenden Restwertangebote und kommen unverzüglich wieder auf Sie zu.
      </p>
    </div>
    <div data-uk-spinner v-if="loading"></div>
    <div>
      <template v-if="vehicles.length && !loading">
        <h4 class="uk-margin-small">Aktuelle Angebote</h4>
        <div class="uk-grid" data-uk-grid>
          <div class="uk-width-1-1" v-for="vehicle in vehicles" :key="vehicle.id">
            <div class="uk-card uk-card-small uk-card-default">
              <div class="uk-card-header">
                <h3 class="uk-card-title">
                  <div class="uk-flex uk-flex-between">
                    <div>
                      {{ vehicle.name }}
                    </div>
                    <div>
                      <span class="uk-h6 uk-text-bold uk-margin-small-right">Angebot endet am:</span>
                      <span class="uk-label uk-label-success uk-text-small">{{ vehicle.endDate }}</span>
                    </div>
                  </div>
                </h3>
              </div>
              <div class="uk-card-body">
                <div class="uk-grid uk-grid-small" uk-grid>
                  <div class="uk-width-expand uk-margin-remove uk-padding-small-left">
                    <ul class="uk-list">
                      <li class="uk-text-bold">Verfügbare Anzahl: {{ vehicle.availableQuantity }}</li>
                      <li>Abgebotsnummer: {{ vehicle.number }}</li>
                      <li class="uk-margin-remove">
                        Leistung: {{ vehicle.powerKw }} kW ({{ vehicle.powerPs }} PS)
                      </li>
                      <li class="uk-margin-remove">
                        Kraftstoff: {{ vehicle.fueltype }}
                      </li>
                    </ul>
                  </div>
                  <div class="uk-width-1-3@m uk-width-1-4@l uk-margin-remove">
                    <div class="uk-align-right">
                      <p class="uk-margin-remove">
                        UPE-Preis (Netto)<br />
                        <span class="uk-text-bold uk-h4">{{ vehicle.priceFormatted }}</span>
                      </p>
                      <p class="uk-margin-small-top">
                        zzgl. Lieferkosten: {{ vehicle.shippingCostsFormatted }}
                      </p>
                    </div>
                  </div>

                  <div class="uk-width-1-3@m uk-width-1-4@l uk-margin-remove uk-padding-small">
                    <offer-modal :vehicle="vehicle" class="uk-align-right uk-text-right"
                      @offerSend="getVehicles"></offer-modal>
                  </div>
                  <div class="uk-width-1-1" v-html="vehicle.description"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="meta && meta.pagination.total_pages > 1" class="uk-width-1-1 uk-margin-small">
            <pagination :pagination="meta.pagination" @pagination:switched="onPaginationSwitch"></pagination>
          </div>
        </div>
      </template>
    </div>
    <div v-if="!loading && !vehicles.length" class="uk-margin-remove uk-h4">
      Keine Fahrzeuge vorhanden!
    </div>
  </div>
</template>
<script>
import ExchangeService from '@/services/exchange.service'
import Pagination from '@/components/Pagination'
import OfferModal from '@/components/exchange/OfferModal.vue'
export default {
  data() {
    return {
      vehicles: [],
      meta: null,
      loading: true
    }
  },
  components: {
    Pagination,
    OfferModal
  },
  mounted() {
    this.getVehicles()
  },
  watch: {
    '$route.query': {
      handler(query) {
        this.getVehicles(1, query)
      },
      deep: true
    }
  },
  methods: {
    async getVehicles(page = this.$route.query.page, query = this.$route.query) {
      const vehicles = await ExchangeService.getList(page, query)
      this.vehicles = vehicles.data.data
      this.meta = vehicles.data.meta
      this.loading = false
    },
    onPaginationSwitch(page) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const currentParams = Object.fromEntries(urlSearchParams.entries());
      const params = Object.assign({}, {...currentParams}, { page })
      this.addParamsToLocation({ ...params })
      this.getVehicles(params)
      window.scrollTo(0,0)
    },
    addParamsToLocation(params) {
      history.pushState(
        {},
        null,
        this.$route.path +
        '?' +
        Object.keys(params)
          .map(key => {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
            )
          })
          .join('&')
      )
    }
  }
}
</script>
  